// ─────────────────────────────────────────────
//  pwaInstall.js — Detectar si la app está instalada como PWA
// ─────────────────────────────────────────────

import { useState, useEffect } from 'react';

export function getIsPwaInstalled() {
	if (typeof window === 'undefined') return false;

	return (
		window.matchMedia('(display-mode: standalone)').matches
		|| window.matchMedia('(display-mode: fullscreen)').matches
		|| window.navigator.standalone === true
	);
}

export function useIsPwaInstalled() {
	const [installed, setInstalled] = useState(getIsPwaInstalled);

	useEffect(() => {
		const update = () => setInstalled(getIsPwaInstalled());
		const queries = ['standalone', 'fullscreen'].map(
			(mode) => window.matchMedia(`(display-mode: ${mode})`)
		);

		queries.forEach((mq) => mq.addEventListener('change', update));
		window.addEventListener('appinstalled', update);

		return () => {
			queries.forEach((mq) => mq.removeEventListener('change', update));
			window.removeEventListener('appinstalled', update);
		};
	}, []);

	return installed;
}
